export const user1Data = [
  { month: "Jan", percentage: 0 },
  { month: "Feb", percentage: 20 },
  { month: "Mar", percentage: 40 },
  { month: "Apr", percentage: 20 },
  { month: "May", percentage: 80 },
  { month: "Jun", percentage: 30 },
  { month: "Jul", percentage: 50 },
  { month: "Aug", percentage: 60 },
  { month: "Sep", percentage: 70 },
  { month: "Oct", percentage: 80 },
  { month: "Nov", percentage: 0 },
  { month: "Dec", percentage: 20 }, // Extra point for a closed loop
];
export const user2Data = [
  { month: "Jan", percentage: 0 },
  { month: "Feb", percentage: 10 },
  { month: "Mar", percentage: 30 },
  { month: "Apr", percentage: 60 },
  { month: "May", percentage: 30 },
  { month: "Jun", percentage: 50 },
  { month: "Jul", percentage: 10 },
  { month: "Aug", percentage: 30 },
  { month: "Sep", percentage: 80 },
  { month: "Oct", percentage: 40 },
  { month: "Nov", percentage: 0 },
  { month: "Dec", percentage: 90 }, // Extra point for a closed loop
];
export const user3Data = [
  { month: "Jan", percentage: 10 },
  { month: "Feb", percentage: 40 },
  { month: "Mar", percentage: 10 },
  { month: "Apr", percentage: 30 },
  { month: "May", percentage: 50 },
  { month: "Jun", percentage: 20 },
  { month: "Jul", percentage: 70 },
  { month: "Aug", percentage: 90 },
  { month: "Sep", percentage: 30 },
  { month: "Oct", percentage: 80 },
  { month: "Nov", percentage: 0 },
  { month: "Dec", percentage: 20 }, // Extra point for a closed loop
];
